'use client'

import { useTranslations } from '@/lib/next-shim'

const inputClassName = 'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'

export type AddressDetails = {
  apartment?: string
  floor?: string
  doorCode?: string
  instructions?: string
}

type AddressDetailsFormProps = {
  value: AddressDetails
  onChange: (details: AddressDetails) => void
}

export function AddressDetailsForm({ value, onChange }: AddressDetailsFormProps) {
  const t = useTranslations()

  const handleChange = (field: keyof AddressDetails) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange({ ...value, [field]: e.target.value })
  }

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">{t('address.apartment')}</label>
          <input
            type="text"
            value={value.apartment || ''}
            onChange={handleChange('apartment')}
            placeholder={t('address.apartmentPlaceholder')}
            className={inputClassName}
          />
        </div>
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">{t('address.floor')}</label>
          <input
            type="text"
            value={value.floor || ''}
            onChange={handleChange('floor')}
            placeholder={t('address.floorPlaceholder')}
            className={inputClassName}
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">{t('address.doorCode')}</label>
        <input
          type="text"
          value={value.doorCode || ''}
          onChange={handleChange('doorCode')}
          placeholder={t('address.doorCodePlaceholder')}
          className={inputClassName}
        />
      </div>
      <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">{t('address.instructions')}</label>
        <textarea
          value={value.instructions || ''}
          onChange={handleChange('instructions')}
          placeholder={t('address.instructionsPlaceholder')}
          rows={2}
          className={inputClassName}
        />
      </div>
    </div>
  )
}
